import { api } from "@shared/lib/api";
import {
  BackednResponse,
  ICreateDeliverableFormat,
  IDeliverableConfigurator,
  IDeliverableConfiguratorResponse,
  IUpdateDeliverableFormat,
  IUpdateDeliverableSubtype,
} from "@shared/lib/types";

export class DeliverableConfiguratorService {
  public static async getDeliverables() {
    return (await api
      .post("brief/configurator/deliverable/search")
      .json()) as BackednResponse<IDeliverableConfiguratorResponse>;
  }
  public static async createDeliverableConfig(data: IDeliverableConfigurator) {
    return (await api
      .put("brief/configurator/deliverable", { json: { ...data } })
      .json()) as BackednResponse<IDeliverableConfigurator>;
  }

  public static async createDeliverableFormat(data: ICreateDeliverableFormat) {
    return (await api
      .put("brief/configurator/deliverable/deliverable", { json: { ...data } })
      .json()) as BackednResponse<ICreateDeliverableFormat>;
  }

  public static async updateDeliverableFormat(data: IUpdateDeliverableFormat) {
    return (await api
      .post("brief/configurator/deliverable/deliverable", { json: { ...data } })
      .json()) as BackednResponse<ICreateDeliverableFormat>;
  }

  public static async updateDeliverableSubtype(
    data: IUpdateDeliverableSubtype
  ) {
    return (await api
      .post("brief/configurator/deliverable/deliverable/sub-type", {
        json: { ...data },
      })
      .json()) as BackednResponse<ICreateDeliverableFormat>;
  }

  public static async syncMediaRights(
    data: {
      name: string;
      description: string;
    }[]
  ) {
    return (await api
      .post("brief/configurator/media-rights-duration", {
        json: { types: data },
      })
      .json()) as BackednResponse<
      {
        name: string;
        description: string;
      }[]
    >;
  }
  public static async getMediaRights() {
    return (await api
      .get("brief/configurator/media-rights-duration")
      .json()) as BackednResponse<{
      types: {
        name: string;
        description: string;
      }[];
    }>;
  }
}
